import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { images } from '../../../Constants/ImageUrls';
import { removeDefaultParams } from '../../../Utils/helper';
import { MainContainer } from './styled';

export default function RaiseHappinessSection({ isAboutUsPage }) {
  const router = useRouter();
  return (
    <MainContainer isAboutUsPage={isAboutUsPage}>
      <div className="myloInfo">
        <img
          style={{ aspectRatio: '6/5' }}
          src={images.headingLogo}
          alt="Mylo Logo"
          title="Mylo Logo"
        />
        <p>Start Exploring</p>
        <div className="brands">
          <Link
            href={{
              pathname: '/category/mylo-care-7545',
              query: removeDefaultParams(router.query),
            }}
            locale={false}
            passHref
          >
            CARE
          </Link>
          <Link
            href={{
              pathname: '/category/mylo-baby-7546',
              query: removeDefaultParams(router.query),
            }}
            locale={false}
            passHref
          >
            BABY
          </Link>
          <Link
            href={{
              pathname: '/parenting',
              query: removeDefaultParams(router.query),
            }}
            locale={false}
            passHref
          >
            COMMUNITY
          </Link>
        </div>
      </div>
      <img
        className="bgWave"
        src="https://images.myloapp.in/NestJsUploads/1697705287171-Rectangle-20297.webp"
        alt="wave"
        title="wave"
        loading="lazy"
      />
      <img
        className="bgWaveMobile"
        src="https://images.myloapp.in/NestJsUploads/1697706616725-Subtract.webp"
        alt="wave"
        title="wave"
        loading="lazy"
      />
    </MainContainer>
  );
}
